export default __webpack_public_path__ + "static/media/image-four.d2ea51fa.jpg";